'use client';
import styled from 'styled-components';

export const Wrapper = styled.header`
  width: 100%;
`;
